var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c("div", [
        _c(
          "form",
          {
            ref: "updateEventForm",
            attrs: { novalidate: "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return (() => {}).apply(null, arguments)
              },
            },
          },
          [
            _c("FormHeader", {
              attrs: {
                loading: _vm.loading,
                disabled: _vm.disabled,
                link: "page-events",
                title: _vm.data.title
                  ? `${_vm.data.title} событие: ${_vm.category.title}`
                  : `Создать событие: ${_vm.category.title}`,
              },
            }),
            _c(
              "v-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "8" } },
                  [
                    _c("HeaderSteppers", {
                      attrs: {
                        tabs: _vm.$options.tabsNav,
                        rules: _vm.validationErrors,
                        isNew: _vm.isNew,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "0",
                          fn: function () {
                            return [
                              _c("FormEventMain", {
                                attrs: {
                                  loading: _vm.loading,
                                  disabled: _vm.disabled,
                                  data: _vm.fields,
                                  category: _vm.category,
                                  "validation-errors": _vm.validationErrors,
                                  isNew: _vm.isNew,
                                  "event-attributes": _vm.fields.attributes,
                                },
                                on: {
                                  "change:title": function ($event) {
                                    _vm.fields.title = $event
                                  },
                                  "change:slug": function ($event) {
                                    _vm.fields.slug = $event
                                  },
                                  "input:slug": _vm.$v.fields.slug.$touch,
                                  "change:bookingType": function ($event) {
                                    _vm.fields.bookingType = $event
                                  },
                                  "change:subtitle": function ($event) {
                                    _vm.fields.subtitle = $event
                                  },
                                  "change:thumbnailId": function ($event) {
                                    _vm.fields.thumbnailId = $event
                                  },
                                  "change:images": function ($event) {
                                    _vm.fields.images = $event
                                  },
                                  "change:price": function ($event) {
                                    _vm.fields.price = Number($event)
                                  },
                                  "change:description": function ($event) {
                                    _vm.fields.description = $event
                                  },
                                  onChangeContent: function ($event) {
                                    return _vm.$emit(
                                      "change:descriptionForMobile",
                                      $event
                                    )
                                  },
                                  "change:ageRestriction": function ($event) {
                                    _vm.fields.ageRestriction = Number($event)
                                  },
                                  "set-location": _vm.setLocation,
                                  "update-location": _vm.updateLocation,
                                  "update-attribute-value":
                                    _vm.updateAttributeValue,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "1",
                          fn: function () {
                            return [
                              _vm.isEventSchedulesLoading
                                ? _c(
                                    "div",
                                    { staticClass: "wrapper" },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      !_vm.getEventSchedulesArrayLength
                                        ? [
                                            _c("ErrorMessage", {
                                              attrs: {
                                                message:
                                                  "Хотя бы одно расписание обязательно",
                                              },
                                            }),
                                          ]
                                        : [
                                            _c(
                                              "PageContent",
                                              { attrs: { height: "65" } },
                                              _vm._l(
                                                _vm.eventSchedules,
                                                function (
                                                  eventSchedule,
                                                  eventScheduleIndex
                                                ) {
                                                  return _c(
                                                    "v-row",
                                                    { key: eventSchedule.id },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "CardEventSchedules",
                                                            {
                                                              attrs: {
                                                                item: eventSchedule,
                                                                "item-index":
                                                                  eventScheduleIndex,
                                                                isFormLoading:
                                                                  _vm.loading,
                                                                isMutationLoading:
                                                                  _vm.disabled,
                                                                "is-only-edit":
                                                                  _vm.isPrimaryCategoryMovie,
                                                              },
                                                              on: {
                                                                edit: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.editSchedule(
                                                                    eventSchedule,
                                                                    eventScheduleIndex
                                                                  )
                                                                },
                                                                "delete-event-shedule":
                                                                  _vm.eventScheduleDeleteHandler,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                      _c(
                                        "v-container",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass:
                                                "flex flex-row justify-lg-space-between",
                                            },
                                            [
                                              !_vm.isPrimaryCategoryMovie
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        loading: _vm.loading,
                                                        disabled: _vm.disabled,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.addScheduleClick,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Добавить расписание "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    loading: _vm.loading,
                                                    disabled: _vm.disabled,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "generate-event-schedule"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Сгенерировать расписание"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "2",
                          fn: function () {
                            return [
                              _vm.isEventSeatingLoading
                                ? _c(
                                    "div",
                                    { staticClass: "wrapper" },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "PageContent",
                                    [
                                      _c("FormEventPlaces", {
                                        attrs: {
                                          data: _vm.seating,
                                          loading: _vm.loading,
                                          "event-id": _vm.data.id,
                                          "is-only-edit":
                                            _vm.isPrimaryCategoryMovie,
                                        },
                                        on: {
                                          "delete-seat-row": function ($event) {
                                            return _vm.$emit(
                                              "delete-seat-row",
                                              $event
                                            )
                                          },
                                          "delete-seat-zone": function (
                                            $event
                                          ) {
                                            return _vm.$emit(
                                              "delete-seat-zone",
                                              $event
                                            )
                                          },
                                          "delete-seat": function ($event) {
                                            return _vm.$emit(
                                              "delete-seat",
                                              $event
                                            )
                                          },
                                          seating: function ($event) {
                                            return _vm.$emit("seating", $event)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "3",
                          fn: function () {
                            return [
                              _vm.isEventTicketGroupsLoading ||
                              _vm.isEventSeatingLoading
                                ? _c(
                                    "div",
                                    { staticClass: "wrapper" },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "PageContent",
                                    [
                                      _c("FormEventTickets", {
                                        attrs: {
                                          data: _vm.ticketGroups,
                                          loading:
                                            _vm.isEventTicketGroupsLoading,
                                          "event-schedules": _vm.eventSchedules,
                                          "event-seat-zones": _vm.getZones,
                                          "is-only-edit":
                                            _vm.isPrimaryCategoryMovie,
                                        },
                                        on: {
                                          "ticket-update":
                                            _vm.updateTicketHandler,
                                          remove: function ($event) {
                                            return _vm.$emit(
                                              "delete-ticket-group",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "4" } },
                  [
                    _c("ManageSidePanel", {
                      attrs: {
                        isShowSortOrder: "",
                        "is-new": !_vm.data.id,
                        "created-at": _vm.data.createdAt,
                        "updated-at": _vm.data.updatedAt,
                        "published-at": _vm.data.publishedAt,
                        author: _vm.data.author,
                        "is-loading": _vm.loading,
                        "is-submit-disabled":
                          _vm.disabled || _vm.isPrimaryCategoryMovie,
                        language: _vm.language,
                        "entity-id": _vm.data.id,
                        "entity-type": "event",
                        translations: _vm.fields.translations,
                        sortOrder: _vm.fields.sortOrder,
                        "tooltip-msg": _vm.isPrimaryCategoryMovie
                          ? "Запрещено редактирование событий с категорией Кино"
                          : "",
                      },
                      on: {
                        delete: function ($event) {
                          return _vm.$emit("delete-event")
                        },
                        cancel: function ($event) {
                          return _vm.$router.push({ name: "page-events" })
                        },
                        submit: _vm.submit,
                        "update-translations": function ($event) {
                          return Object.assign(_vm.fields.translations, $event)
                        },
                        "language-update": function ($event) {
                          return _vm.$emit("language-update", $event)
                        },
                        "update-sort-order": function ($event) {
                          _vm.fields.sortOrder = Number($event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "info-append",
                          fn: function () {
                            return [
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _vm._v(" Резерваций:"),
                                  ]),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "page-orders-event",
                                              query: { id: _vm.data.id },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.reservationsCount) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("StatusPicker", {
                                attrs: {
                                  align: "center",
                                  cols: "12",
                                  title: "Статус:",
                                  disabled: _vm.disabled,
                                  loading: _vm.loading,
                                  status: _vm.fields.status,
                                },
                                on: {
                                  "status:change": function ($event) {
                                    _vm.fields.status = $event
                                  },
                                },
                              }),
                              !_vm.isNew
                                ? _c(
                                    "v-row",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c("span", [
                                          _vm._v("Посмотреть на сайте"),
                                        ]),
                                      ]),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                link: "",
                                                color: "primary",
                                                target: "_blank",
                                                href: _vm.redirerectToWebPortal,
                                                disabled: _vm.disabled,
                                                loading: _vm.loading,
                                              },
                                            },
                                            [_c("v-icon", [_vm._v("mdi-web")])],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-6",
                                      attrs: { cols: "6" },
                                    },
                                    [_vm._v(" Архивировано:")]
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          inset: "",
                                          dense: "",
                                          "hide-details": "",
                                          disabled: _vm.disabled,
                                          loading: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.isArchived,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "isArchived",
                                              $$v
                                            )
                                          },
                                          expression: "fields.isArchived",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-6",
                                      attrs: { cols: "6" },
                                    },
                                    [_vm._v(" Не отображать на тур. портале:")]
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          inset: "",
                                          dense: "",
                                          "hide-details": "",
                                          disabled: _vm.disabled,
                                          loading: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.notListedOnPortal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "notListedOnPortal",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fields.notListedOnPortal",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-subtitle",
                                    { staticClass: "grey--text" },
                                    [_vm._v(" Связи")]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _vm.category
                                        ? _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Категория"),
                                                  ]),
                                                  _c("v-select", {
                                                    attrs: {
                                                      chips: "",
                                                      disabled: "",
                                                      outlined: "",
                                                      dense: "",
                                                      "item-value": "id",
                                                      "item-text": "title",
                                                      "return-object": "",
                                                      clearable: "",
                                                      value: _vm.category,
                                                      items: _vm.categories,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Альтернативные категории"
                                                ),
                                              ]),
                                              _c("v-select", {
                                                attrs: {
                                                  chips: "",
                                                  multiple: "",
                                                  outlined: "",
                                                  dense: "",
                                                  "item-value": "id",
                                                  "item-text": "title",
                                                  items: _vm.categories.filter(
                                                    (categoryItem) =>
                                                      categoryItem.id !==
                                                      _vm.primaryCategory
                                                  ),
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                  "return-object": "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.fields.altCategories,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "altCategories",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "fields.altCategories",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          !!_vm.cities
                                            ? _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Город*"),
                                                  ]),
                                                  _c("v-select", {
                                                    attrs: {
                                                      id: "city",
                                                      chips: "",
                                                      outlined: "",
                                                      dense: "",
                                                      "item-value": "id",
                                                      "item-text": "title",
                                                      clearable: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                      items: _vm.cities,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .cityId,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "selection",
                                                          fn: function ({
                                                            item,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-chip",
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.title
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        icon: "",
                                                                        "x-small":
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            _vm.fields.cityId =
                                                                              null
                                                                            _vm.fields.placeId =
                                                                              null
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            " mdi-close"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      1164947137
                                                    ),
                                                    model: {
                                                      value: _vm.fields.cityId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "cityId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.cityId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          !!_vm.places
                                            ? _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [_vm._v("Место")]),
                                                  _c("PlacePicker", {
                                                    attrs: {
                                                      dense: "",
                                                      loading: _vm.loading,
                                                      value: _vm.fields.placeId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.placeId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c("Organizer", {
                                            attrs: {
                                              profileType:
                                                _vm.fields.profileType,
                                              profileId: _vm.fields.profileId,
                                              profileTypeError:
                                                _vm.validationErrors
                                                  .profileType,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              "input:profile-type": function (
                                                $event
                                              ) {
                                                _vm.fields.profileType = $event
                                              },
                                              "input:profile-id": function (
                                                $event
                                              ) {
                                                _vm.fields.profileId = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("FormDialogEvent", {
              ref: "FormDialogEvent",
              attrs: {
                eventId: _vm.data.id,
                data: _vm.eventSchedule,
                idx: _vm.eventScheduleIdx,
                timezone: _vm.getTimeZone,
                "is-only-edit": _vm.isPrimaryCategoryMovie,
              },
              on: {
                "change-event-schedules": _vm.ChangeEventScheduleHandler,
                "delete-event-shedule": _vm.eventScheduleDeleteHandler,
              },
            }),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }